import { render, staticRenderFns } from "./CountryForm.vue?vue&type=template&id=2f6b0723&scoped=true&"
import script from "./CountryForm.vue?vue&type=script&lang=js&"
export * from "./CountryForm.vue?vue&type=script&lang=js&"
import style0 from "./CountryForm.vue?vue&type=style&index=0&id=2f6b0723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b0723",
  null
  
)

export default component.exports